import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 11C11 10.4477 11.4477 9.99999 12 9.99999C12.5523 9.99999 13 10.4477 13 11V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V11Z M11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17Z M 11.1221,1.60947 c 0.379,-0.694868 1.3768,-0.694868 1.7558,0 L 23.1933,20.5211 C 23.5568,21.1875 23.0745,22 22.3154,22 H 1.68452 C 0.925459,22 0.443146,21.1875 0.806623,20.5211 Z M 20.6309,20 12,4.17665 3.36906,20 Z"
  }));
});
var NotificationError = AbstractIcon.withComponent(Icon);
NotificationError.displayName = 'NotificationError';
export default NotificationError;